export enum ESuitSymbol {
  SPADE = '♠',
  HEART = '♥',
  DIAMOND = '♦',
  CLUB = '♣',
}
